import React from 'react';
import styles from '../styles/EventPopupModal.module.css'; // We'll create this CSS file next

const EventPopupModal = ({ isOpen, onClose, events }) => {
    if (!isOpen || !events || events.length === 0) {
        return null;
    }

    return (
        <div className={styles.modalBackdrop} onClick={onClose} role="dialog" aria-modal="true" aria-labelledby="eventModalTitle">
            <div className={styles.modalContent} onClick={(e) => e.stopPropagation()}>
                <h2 id="eventModalTitle" className={styles.modalTitle}>Today's Events & Reminders</h2>
                <ul className={styles.eventsListModal}>
                    {events.map(event => (
                        <li key={event.id} className={`${styles.eventItemModal} ${styles[`eventTypeModal_${event.type}`] || ''}`}>
                            {event.message}
                        </li>
                    ))}
                </ul>
                <button onClick={onClose} className={styles.closeButtonModal} aria-label="Dismiss events popup">
                    Dismiss
                </button>
            </div>
        </div>
    );
};

export default EventPopupModal;